<template>
  <div>
    <div class="container-fluid bg-light py-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t("blogDetail") }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item"><a href="#">{{ $t("home") }}</a></li>
          <li class="breadcrumb-item"><a href="#">{{ $t('blogs') }}</a></li>
          <li class="breadcrumb-item text-dark" aria-current="page">
            {{ $t('blogDetail') }}
          </li>
        </ol>
      </div>
    </div>
    <div class="container animated bounceInDown">
      <h1 class="text-center my-3">
        {{ getLocalizedTitle(blog) }}
      </h1>
      <p class="text-justify" v-html="getLocalizedDescription(blog)"></p>
      <!-- <img
        :src="getImageUrl(blog.cover_photo_url)"
        alt=""
        style="display: block; margin: 0 auto; max-width: 400px"
      /> -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 p-3" v-for="file in blog.files" :key="file.id">
          <img :src="getImageUrl(file.url)" alt="" style="display: block; margin: 0 auto;" width="100%"/>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mediaUrl from "../utils/mediaUrl";

export default {
  props: {
    id: String,
  },
  computed: mapGetters(["blog"]),
  methods: {
    ...mapActions(["getBlogDetail"]),
    getImageUrl(imageUrl) {
      return mediaUrl(imageUrl);
    },
    getLocalizedTitle(blog) {
      const locale = this.$i18n.locale;
      if (locale === 'en') return blog.title_en ? blog.title_en : blog.title_en;
      if (locale === 'mm') return blog.title_mm ? blog.title_mm : blog.title_en;
      if (locale === 'jp') return blog.title_jp ? blog.title_jp : blog.title_en;
    },
    getLocalizedDescription(blog) {
      const locale = this.$i18n.locale;
      if (locale === 'en') return blog.description_en ? blog.description_en : blog.description_en;
      if (locale === 'mm') return blog.description_mm ? blog.description_mm : blog.description_en;
      if (locale === 'jp') return blog.description_jp ? blog.description_jp : blog.description_en;
    }
  },
  mounted() {
    this.getBlogDetail(this.id);
  },
};
</script>

<style></style>
